import loadingDirective from './loading'
export default{
	install: function(app, options) {
    app.use(loadingDirective);
  }
}
